import { render } from "./zzsptfpjp.vue?vue&type=template&id=199b547c&scoped=true"
import script from "./zzsptfpjp.vue?vue&type=script&lang=js"
export * from "./zzsptfpjp.vue?vue&type=script&lang=js"

import "./zzsptfpjp.vue?vue&type=style&index=0&id=199b547c&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-199b547c"]])

export default __exports__